export default function functioning(data) {
    if (data.tipo == "1ºdeposito") {
      return `
        1. A participação na promoção implica a aceitação integral dos termos e condições da mesma.<br/>
        2. O bônus é válido apenas para clientes cadastrados no site que efetuarem seu primeiro depósito até o dia <strong>${new Date(data.data_final.replace(" ", "T")).toLocaleString()}</strong>.<br/>
        3. Para usufruir desta promoção, insira no momento do seu primeiro depósito o código promocional <strong>${data.codigo}</strong>.<br/>
        4. Qualifica-se para este bônus o primeiro depósito igual ou superior a R$ <strong>${parseFloat(data.deposito_min).toFixed(2)}</strong>.<br/>
        5. Seu bônus será adicionado automaticamente somente após o depósito ter sido consolidado com sucesso.<br/>
        6. Para saber como transferir seu saldo bônus para saldo real, consulte as regras da promoção.<br/>
        7. Divirta-se com o saldo bônus! <br/>
        `;
    } else if (data.tipo == "cadastro") {
      return `
        1. A participação na promoção implica a aceitação integral dos termos e condições da mesma.<br/>
        2. O bônus é válido apenas para clientes que se cadastrarem no site até o dia <strong>${new Date(data.data_final.replace(" ", "T")).toLocaleString()}</strong>.<br/>
        3. Para usufruir desta promoção, insira no momento do seu cadastro o código promocional <strong>${data.codigo}</strong>.<br/>
        5. Seu bônus será adicionado automaticamente somente após o cadastro e a verificação de email terem sido feitos com sucesso.<br/>
        6. Para saber como transferir seu saldo bônus para saldo real, consulte as regras da promoção.<br/>
        7. Divirta-se com o saldo bônus!<br/>
        `;
    } else if (data.tipo == "deposito") {
      return `
        1. A participação na promoção implica a aceitação integral dos termos e condições da mesma. <br/>
        2. O bônus é válido apenas para clientes cadastrados no site que efetuarem um depósito até o dia <strong>${new Date(data.data_final.replace(" ", "T")).toLocaleString()}</strong>. <br/>
        3. Para usufruir desta promoção, após ativar a promoção insira no momento do seu depósito o código promocional <strong>${data.codigo}</strong>. <br/>
        4. Qualifica-se para este bônus um depósito igual ou superior a R$ <strong>${parseFloat(data.deposito_min).toFixed(2)}</strong>. <br/>
        5. Seu bônus será creditado após o depósito ter sido consolidado com sucesso. <br/>
        6. Divirta-se com o saldo bônus! <br/>
          `;
    } else if (data.tipo == "afiliado") {
      return `
        1. A participação na promoção implica a aceitação integral dos termos e condições da mesma.<br/>
        2. O bônus é válido apenas para clientes que se cadastrarem no site até o dia <strong>${new Date(data.data_final.replace(" ", "T")).toLocaleString()}</strong>.<br/>
        3. Ao aderir esta promoção você será um afiliado de <strong>${data.affiliateName}</strong>.<br/> 
        4. Para usufruir desta promoção, insira no momento do seu cadastro o código promocional <strong>${data.codigo}</strong>.<br/>
        5. Seu bônus será adicionado automaticamente somente após o cadastro e a verificação de email terem sido feitos com sucesso.<br/>
        6. Para saber como transferir seu saldo bônus para saldo real, consulte as regras da promoção.<br/>
        7. Divirta-se com o saldo bônus! 
        `;
    } else if (data.tipo == "token") {
      // usando o funcionamento com base em cadastro para fins de testes - ainda será definido o texto
      return `
        1. A participação na promoção implica a aceitação integral dos termos e condições da mesma.<br/>
        2. O bônus é válido apenas para clientes que se cadastrarem no site até o dia <strong>${new Date(data.data_final.replace(" ", "T")).toLocaleString()}</strong>.<br/>
        3. Para poder participar desta promoção, o usuário deve resgatar o seu TOKEN no momento do cadastro, ou na página "Minhas promoções" ou na página "Promoções".<br/>
        4. Somente depois que o seu TOKEN for validado é que o seu bônus será adicionado automaticamente.<br/>
        5. Para saber como transferir seu saldo bônus para saldo real, consulte as regras da promoção.<br/>
        6. Divirta-se com o saldo bônus!<br/>
        `;
    } else if (data.campaign_type == '1ºdeposito') {
      // Promoções de Freespin
      return `
        1. A participação na promoção implica a aceitação integral dos termos e condições da mesma.<br/>
        2. O bônus é válido apenas para clientes cadastrados no site que efetuarem seu primeiro depósito até
        o dia <strong>${new Date(
          data.final_date.replace(" ", "T")
        ).toLocaleString()}</strong>.<br/>
        3. Para usufruir desta promoção, insira no momento do seu depósito o código promocional 
        <strong>${data.campaign_code}</strong>.<br/>
        4. Qualifica-se para este bônus o primeiro depósito igual ou superior a R$ <strong>${parseFloat(
          data.min_deposit
        ).toFixed(2)}</strong>.<br/>
        5. Divirta-se!
      `;
    } else if (data.campaign_type == 'deposito') {
      // Promoções de Freespin
      return `
        1. A participação na promoção implica a aceitação integral dos termos e condições da mesma.<br/>
        2. O bônus é válido apenas para clientes cadastrados no site que efetuarem seu depósito até
        o dia <strong>${new Date(
          data.final_date.replace(" ", "T")
        ).toLocaleString()}</strong>.<br/>
        3. Para usufruir desta promoção, insira no momento do seu depósito o código promocional 
        <strong>${data.campaign_code}</strong>.<br/>
        4. Qualifica-se para este bônus o depósito igual ou superior a R$ <strong>${parseFloat(
          data.min_deposit
        ).toFixed(2)}</strong>.<br/>
        5. Divirta-se!
      `;
    }
  }